import { BaseModel } from "models/common/basemodel";

export interface DashboardData {
    salesOtc: GraphGroup;
    salesScript: GraphGroup;
    scriptsPaper: GraphGroup;
    scriptsPaperless: GraphGroup;
    scriptsOwing: GraphGroup;
    grossProfitOtc: GraphGroup;
    grossProfitScript: GraphGroup;
    optimalBrandCount: GraphGroup;
    optimalBrandTotal: GraphGroup;
    optimalBrandLost: GraphGroup;
    customerData: { [key: string]: number; };
    basketStatsOtc: GraphGroup;
    basketStatsScripts: GraphGroup;
    basketStatsRefunds: GraphGroup;
    basketStatsOtcDollar: GraphGroup;
    basketStatsScriptsDollar: GraphGroup;
    basketStatsRefundsDollar: GraphGroup;
    basketStatsReceiptCount: GraphGroup;
    stockValue: GraphGroup;
    lastUpdated: string;
    dbInfo: DatabaseInfo;
    quickStatAmounts: { [key: string]: number; };

}

export interface GraphGroup {
    year0: GraphData;
    year1: GraphData;
    year2: GraphData;
    year3: GraphData;
    thisMonth: GraphData;
    lastMonth: GraphData;
    thisWeek: GraphData;
    lastWeek: GraphData;
    today: GraphData;
    yesterday: GraphData;
}

export interface GraphData {
    axis: string[];
    values: number[];
    additionalValues: { [key: string]: string; };
}

export enum DataType {
    Year,
    Month,
    Week,
    Day
}

export interface DatabaseInfo {
    maxDbSize: number;
    usedDbSize: number;
}

export interface AdminDashboard {
    title: string;
    key: string;
    statistic: number | null;
    trend: AdminDashboardTrend | undefined;
    rightPanel?: Record<string, string>;
    leftPanel?: Record<string, string>;
    additionalInfo: string;
}

export interface AdminDashboardTrend {
    value: number | undefined;
    time: string | undefined;
}


export interface DashboardBaseData {
    name: string;
    captureDate: string;
    fromDate: string | null;
    toDate: string | null;
    type: string;
}

export interface DashboardTimeBasedData<T> extends DashboardBaseData {
    data: { [K in keyof T]: number[]; };
}

export interface DashboardDetailedTimeBasedStats<T> extends DashboardTimeBasedData<T> {
    reportData: CustomReportResponse;
}

export interface DashboardDataStats<T> extends DashboardBaseData {
    data: { [K in keyof T]: number; };
}

export interface DashboardDetailedDataStats<T> extends DashboardDataStats<T> {
    reportData: CustomReportResponse;
}

export interface CustomReportResponse {
    rows: { [key: string]: any; }[];
    displayColumns: { [key: string]: string; };
    totalRows?: number;
}

export enum TileTypes {
    DashboardTimeBasedData,
    DashboardDetailedTimeBasedStats,
    DashboardDataStats,
    DashboardDetailedDataStats
}

export enum AverageBasket {
    ReceiptCount,
    Refund,
    RefundDollar,
    OtcCount,
    OtcDollar,
    ScriptCount,
    ScriptDollar
}

export enum CustomerStats {
    ActiveTotal,
    Mobile,
    Email,
    Dob,
    AslConsent,
    RepeatsHeld
}

export enum DatabaseStats {
    DatabaseMaxSize,
    DatabaseUserSize
}

export enum NegativeSoh {
    Count,
    Soh,
    Value
}

export enum OptimalBrand {
    OptimalBrandScripts,
    TotalOptimalScriptCount,
    MoneyLost
}

export enum PendingPriceChanges {
    Count,
    Enabled
}

export enum SalesNegativeGP {
    Count,
    TotalSalesGP,
    TotalRounding,
}

export enum StocksCreatedAtStore {
    Count
}

export enum TotalGP {
    GrossProfitScript,
    GrossProfitOtc,
    Value
}

export enum TotalInvoices {
    TotalCostEx
}

export enum TotalSales {
    SalesScript,
    SalesOtc,
    SalesValue
}

export enum TotalScripts {
    PaperlessValue,
    PaperValue,
    OwingValue,
    Count
}